import BrowsePage from "../components/browse-page";

/**
 * The home page fetches NOTHING on the server.
 *
 * It used to pull the first four showcase rows in `getStaticProps` behind
 * `revalidate: 3600`, which is a contradiction once rows are ordered per buyer:
 * an ISR cache serves one buyer's ordering to everyone for an hour. The rows
 * are now fetched client-side by `useHomeShowcases`, off the session's own
 * interest vector.
 *
 * `getStaticProps` stays only to hand three layout constants to
 * `CompositeAppProvider` through `pageProps`. It performs no data access and
 * declares no `revalidate`, so the page is a plain static shell -- which is
 * also why `utils/revalidate-listing.ts` no longer revalidates `/`.
 *
 * The Capacitor build already shipped an empty `homeShowcases` array, so the
 * client-only path has been running in production all along.
 */
export async function getStaticProps() {
  return {
    props: {
      mobileTopNav: "left",
      currentCatId: 0,
      interceptBack: true,
    },
  };
}

export default BrowsePage;
